import * as React from "react";

function SvgMoveToStorage(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M2.833 0L0 2.833l4.25 4.25-2.833 2.834h8.5v-8.5L7.083 4.25 2.833 0z"
        fill="#414042"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.333 23.697l1.971-2.06h12.812V34H11.333V23.697zm12.812 0h-1.971v2.06h1.97v-2.06zm-2.957 0h-1.97v2.06h1.97v-2.06zm-2.956 0H16.26v2.06h1.97v-2.06zm-2.957 0h-1.97v2.06h1.97v-2.06zm6.899 3.09h1.97v2.062h-1.97v-2.061zm0 3.092h1.97v2.06h-1.97v-2.06zm-8.87 2.06h1.971v-2.06h-1.97v2.06zm2.957 0h1.97v-2.06h-1.97v2.06zm2.956 0h1.971v-2.06h-1.97v2.06zm1.971-5.151v2.06h-1.97v-2.06h1.97zm-2.956 0v2.06H16.26v-2.06h1.97zm-2.957 0v2.06h-1.97v-2.06h1.97z"
        fill="#414042"
      />
      <path
        d="M19.217 13.394l1.971-2.06H34v12.363h-2.956v-2.06h.985v-2.061h-.986v-1.03h.986v-2.061h-.986v-1.03h.986v-2.061h-1.971v2.06h-.985v-2.06H27.1v2.06h-.985v-2.06h-1.971v2.06h-.986v-2.06h-1.97v2.06h-1.972v-2.06z"
        fill="#414042"
      />
      <path
        d="M15.275 18.546l1.971-2.061h12.812v12.364h-2.957v-2.061h.986v-2.06h-.986v-1.031h.986v-2.06h-.986v-1.03h.986v-2.061h-1.971v2.06h-.986v-2.06h-1.97v2.06h-.986v-2.06h-1.971v2.06h-.986v-2.06h-1.97v2.06h-1.972v-2.06z"
        fill="#414042"
      />
    </svg>
  );
}

export default SvgMoveToStorage;
